























import { Component, Inject, Prop, Mixins } from 'vue-property-decorator';
import { AxiosInstance } from 'axios';
import { LoaderMixin } from '@/pages/profile/mixins';
import { eventsService, ParsedEvents } from '@/services';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import ItemSingle from '@/components/parts/catalog/list/item/single';
import { AppHeading, CardtabLayout } from '@/uikit';

@Component({
  components: {
    ItemSingle,
    AppHeading,
    CardtabLayout,
  },

  inheritAttrs: false,
})
export default class Program extends Mixins(LoaderMixin) {
  @Inject() $api: AxiosInstance;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  professions: ParsedEvents = [];
  error: boolean = false;

  async mounted() {
    try {
      const { data } = await eventsService(this.$api).getEvents({
        profession: this.id,
      });

      if (isArrayNotEmpty(data)) this.professions = data;
      this.setStatus('success');
    } catch (err) {
      this.error = true;
      this.setStatus('success');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/professions/card/program/Program.vue